module.exports = function() {
  return new Worker(__webpack_public_path__ + "51366c38ee5efa958d9a.worker.js");
};